import Vue from 'vue'
import API from '../../../api/endpoints'

export default {
  login (data) {
    return Vue.http.post(API.LOGIN, data)
  },
  checkAuth () {
    return Vue.http.post(API.CHECK_AUTH)
  },
  refreshToken () {
    return Vue.http.post(API.REFRESH_TOKEN, {})
  },
  healthCheck () {
    return Vue.http.get(API.HEALTH_CHECK, {})
  },
  healthCheckOpti () {
    return Vue.http.get(API.HEALTH_CHECK_OPTI, {})
  }
}



// WEBPACK FOOTER //
// ./src/modules/authentication/store/service.js